/* eslint-disable max-len */
import React from 'react';

export default function CoinsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      fill="none"
      viewBox="0 0 23 23"
    >
      <path
        fill="#FFC107"
        d="M7.188 15.094v1.437c0 1.986 3.54 3.594 7.906 3.594S23 18.517 23 16.531v-1.437H7.187z"
      />
      <path
        fill="#FFD54F"
        d="M15.094 18.688c4.366 0 7.906-1.61 7.906-3.594 0-1.985-3.54-3.594-7.906-3.594-4.367 0-7.906 1.609-7.906 3.594 0 1.984 3.54 3.594 7.906 3.594z"
      />
      <path
        fill="#FFE082"
        d="M20.125 17.865v1.438a7.521 7.521 0 001.438-.71V17.25h-.158c-.373.23-.8.436-1.28.615zM17.25 18.548v1.438c.503-.063.984-.153 1.438-.256v-1.438c-.454.108-.935.193-1.438.256z"
      />
      <path
        fill="#FFC107"
        d="M7.188 12.219v1.437c0 1.986 3.54 3.594 7.906 3.594S23 15.642 23 13.656V12.22H7.187z"
      />
      <path
        fill="#FFD54F"
        d="M15.094 15.813c4.366 0 7.906-1.61 7.906-3.594 0-1.985-3.54-3.594-7.906-3.594-4.367 0-7.906 1.609-7.906 3.594 0 1.985 3.54 3.594 7.906 3.594z"
      />
      <path
        fill="#FFE082"
        d="M20.125 14.99v1.438a7.521 7.521 0 001.438-.71v-1.343h-.158c-.373.23-.8.436-1.28.615zM17.25 15.673v1.438c.503-.063.984-.153 1.438-.256v-1.438c-.454.108-.935.193-1.438.256z"
      />
      <path
        fill="#FFC107"
        d="M7.188 9.344v1.437c0 1.986 3.54 3.594 7.906 3.594S23 12.767 23 10.781V9.344H7.187z"
      />
      <path
        fill="#FFD54F"
        d="M15.094 12.938c4.366 0 7.906-1.61 7.906-3.594 0-1.985-3.54-3.594-7.906-3.594-4.367 0-7.906 1.609-7.906 3.594 0 1.985 3.54 3.594 7.906 3.594z"
      />
      <path
        fill="#FFE082"
        d="M20.125 12.115v1.438a7.521 7.521 0 001.438-.71V11.5h-.158c-.373.23-.8.436-1.28.615zM17.25 12.798v1.438c.503-.063.984-.153 1.438-.256v-1.438c-.454.108-.935.193-1.438.256z"
      />
      <path
        fill="#FFC107"
        d="M7.188 6.469v1.437c0 1.986 3.54 3.594 7.906 3.594S23 9.892 23 7.906V6.47H7.187z"
      />
      <path
        fill="#FFD54F"
        d="M15.094 10.063c4.366 0 7.906-1.61 7.906-3.594 0-1.985-3.54-3.594-7.906-3.594-4.367 0-7.906 1.609-7.906 3.594 0 1.985 3.54 3.593 7.906 3.593z"
      />
      <path
        fill="#FFE082"
        d="M20.125 9.24v1.438a7.519 7.519 0 001.438-.71V8.625h-.158c-.373.23-.8.436-1.28.615zM17.25 9.923v1.438c.503-.063.984-.153 1.438-.256V9.667c-.454.108-.935.193-1.438.256z"
      />
      <path
        fill="#FFC107"
        d="M7.188 3.594V5.03c0 1.986 3.54 3.594 7.906 3.594S23 7.017 23 5.031V3.594H7.187z"
      />
      <path
        fill="#FFD54F"
        d="M15.094 7.188C19.46 7.188 23 5.577 23 3.594 23 1.609 19.46 0 15.094 0c-4.367 0-7.906 1.609-7.906 3.594 0 1.985 3.54 3.594 7.906 3.594z"
      />
      <path
        fill="#FFE082"
        d="M20.125 6.365v1.438a7.521 7.521 0 001.438-.71V5.75h-.158c-.373.23-.8.436-1.28.615zM17.25 7.048v1.438c.503-.063.984-.153 1.438-.256V6.792c-.454.108-.935.193-1.438.256z"
      />
      <path
        fill="#fff"
        d="M7.906 10.063c-.238 0-.543-.01-.786 0v.705c0 .247.032.498.135.732-.103.234-.072.472-.072.719v1.437c0 .247.054.486.157.72a1.757 1.757 0 00-.157.718v1.437c0 1.986 3.54 3.724 7.906 3.724.728 0 1.393-.05 2.062-.13a5.2 5.2 0 00.095-.719v-4.312c.004-3.302-4.695-5.031-9.34-5.031z"
      />
      <path
        fill="#FFC107"
        d="M0 17.969v1.437C0 21.392 3.54 23 7.906 23c4.367 0 7.907-1.608 7.907-3.594V17.97H0z"
      />
      <path
        fill="#FFD54F"
        d="M7.906 21.563c4.367 0 7.907-1.61 7.907-3.594 0-1.985-3.54-3.594-7.907-3.594C3.54 14.375 0 15.984 0 17.969c0 1.984 3.54 3.593 7.906 3.593z"
      />
      <path
        fill="#FFE082"
        d="M12.938 20.74v1.438a7.521 7.521 0 001.437-.71v-1.343h-.157c-.373.23-.8.436-1.28.615zM10.063 21.423v1.438c.503-.063.983-.153 1.437-.256v-1.438c-.454.108-.934.193-1.438.256z"
      />
      <path
        fill="#FFC107"
        d="M0 15.094v1.437c0 1.986 3.54 3.594 7.906 3.594 4.367 0 7.907-1.608 7.907-3.594v-1.437H0z"
      />
      <path
        fill="#FFD54F"
        d="M7.906 18.688c4.367 0 7.907-1.61 7.907-3.594 0-1.985-3.54-3.594-7.907-3.594C3.54 11.5 0 13.109 0 15.094c0 1.984 3.54 3.594 7.906 3.594z"
      />
      <path
        fill="#FFE082"
        d="M12.938 17.865v1.438a7.521 7.521 0 001.437-.71V17.25h-.157c-.373.23-.8.436-1.28.615zM10.063 18.548v1.438c.503-.063.983-.153 1.437-.256v-1.438c-.454.108-.934.193-1.438.256z"
      />
    </svg>
  );
}
